import { render, staticRenderFns } from "./EventsHeader.vue?vue&type=template&id=8a706364&scoped=true"
import script from "./EventsHeader.vue?vue&type=script&lang=ts"
export * from "./EventsHeader.vue?vue&type=script&lang=ts"
import style0 from "./EventsHeader.vue?vue&type=style&index=0&id=8a706364&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a706364",
  null
  
)

export default component.exports